export const BREAK_SYMBOL = "[break]";
